import { W as WuiMoreMenu$1, d as defineCustomElement$1 } from './p-u0Ru81Zp.js';

const WuiMoreMenu = WuiMoreMenu$1;
const defineCustomElement = defineCustomElement$1;

export { WuiMoreMenu, defineCustomElement };
